'use client';

import Link from 'next/link';
import { Home, LayoutGrid } from 'lucide-react';
import { useT } from '@/hooks/useT';

// Клієнтський компонент — локалізується з того ж джерела, що й хедер (PriceContext/
// localStorage), реактивно на зміну мови й незалежно від кешу сторінки.
export default function NotFound() {
  const t = useT();
  return (
    <div style={{
      minHeight: '72vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', textAlign: 'center',
      padding: '48px 20px', position: 'relative', overflow: 'hidden',
    }}>
      <div aria-hidden style={{
        position: 'absolute', width: 560, height: 560, borderRadius: '50%',
        background: 'radial-gradient(circle, color-mix(in srgb, var(--gs-green) 20%, transparent), transparent 68%)',
        filter: 'blur(44px)', pointerEvents: 'none',
      }} />
      <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
        <div style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: 'clamp(96px, 22vw, 168px)', fontWeight: 800, lineHeight: 1,
          background: 'linear-gradient(135deg, var(--gs-green), color-mix(in srgb, var(--gs-green) 45%, #7de3ff))',
          WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent',
          letterSpacing: '-.05em', filter: 'drop-shadow(0 8px 40px color-mix(in srgb, var(--gs-green) 30%, transparent))',
        }}>404</div>
        <h1 style={{
          fontSize: 'clamp(20px, 4vw, 28px)', fontWeight: 800, color: 'var(--fg)', margin: 0,
          fontFamily: "'Space Grotesk', sans-serif",
        }}>{t('nf_title')}</h1>
        <p style={{ fontSize: 15, color: 'var(--fg-3)', maxWidth: 400, margin: 0, lineHeight: 1.65, textWrap: 'balance' }}>
          {t('nf_desc')}
        </p>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center', marginTop: 10 }}>
          <Link href="/" className="gs-cta"><Home size={16} />{t('nf_home')}</Link>
          <Link href="/catalog" className="gs-cta-ghost"><LayoutGrid size={16} />{t('nf_catalog')}</Link>
        </div>
      </div>
    </div>
  );
}
